export default "__VITE_ASSET__458c5037__"